import React, { useEffect, useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { NavLink, useLocation, useNavigate, useParams } from "react-router-dom";
import { routeMapping } from "../GameTypeSelector/utils/routeMapping";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import {
  AbsoluteCenter,
  Box,
  Flex,
  Icon,
  Image,
  Link,
  Text,
  chakra,
  shouldForwardProp,
  useColorMode,
  useColorModeValue,
} from "@chakra-ui/react";
import { COMMON_WEB_PATH } from "../../../constant";
import { thisImageNeedDark } from "../../../utils/thisImageNeedDark";
import { useTranslation } from "react-i18next";
import { gameListFromBottom } from "../../../animateConstant";
import { isValidMotionProp, motion } from "framer-motion";
import useSound from "../../../hook/useSound";

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop),
});

const PlatformSelectorRight = ({ gameMainTypeFromProps, direction }) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);
  const isHandleAllGame = useSelector((state) => state.isHandleAllGame);

  const boxBg = useColorModeValue("#E9E8F2", "#394367");
  const textColor = useColorModeValue("#757576", "#E9E8F2");

  const { colorMode, toggleColorMode } = useColorMode();

  const { gameList } = isHandleAllGame || {};

  const scrollRef = useRef();
  const splideRef = useRef();

  const navigate = useNavigate();
  const location = useLocation();

  const { pathname } = location;

  //   const getGameType = useMemo(() => {
  //     return pathname.split("/")[1];
  //   }, [pathname]);
  const { gameMainType, gamePlatform } = useParams(); // 獲取路由參數
  const playButtonSound = useSound();
  const hoverButtonSound = useSound({
    customSound: "slide_sound",
    volume: 0.3,
  });

  const getPlatform = useMemo(() => {
    const mainType = gameMainTypeFromProps || gameMainType;
    if (gameList) {
      // 通過routeMapping轉換遊戲類型
      const current_game_type = routeMapping(mainType)?.origin;
      return {
        // 獲取該遊戲類型下所有平台
        platform_list: Object?.keys(gameList[current_game_type] || {}),
      };
    }
  }, [gameList, gameMainType, gameMainTypeFromProps]);
  const platformList = useMemo(() => {
    const mainType = gameMainTypeFromProps || gameMainType;
    const { platform_list } = getPlatform || {};
    const current_game_type = routeMapping(mainType)?.origin;

    return platform_list?.map((item) => {
      // 獲取每個平台的遊戲數量
      const game_length = gameList?.[current_game_type]?.[item]?.length;
      return (
        <SplideSlide key={item}>
          <Link
            as={NavLink}
            to={`/${mainType}/category/${item}/AllGames`}
            h={
              direction
                ? "100px"
                : {
                    base: "50px",
                    md: "105px",
                  }
            }
            _hover={{
              textDecoration: "none",
            }}
            onMouseEnter={hoverButtonSound}
            onClick={playButtonSound}
          >
            {({ isActive }) => {
              return (
                <Box position={"relative"}>
                  <Box>
                    <Flex
                      h={{
                        base: "50px",
                        sm: direction
                          ? "100px"
                          : {
                              base: "50px",
                              md: "105px",
                            },
                      }}
                      justifyContent={`center`}
                      gap="2.5px"
                      //direction="column"
                      alignItems={`center`}
                      // bg={isActive ? "brand.500" : boxBg}
                      bgImage={
                        isActive
                          ? `url('${COMMON_WEB_PATH}/now888/platform_list/${
                              direction === "col"
                                ? "platform_list_button"
                                : "platform_list_button_pc"
                            }_active.png')`
                          : `url('${COMMON_WEB_PATH}/now888/platform_list/${
                              direction === "col"
                                ? "platform_list_button"
                                : "platform_list_button_pc"
                            }.png')`
                      }
                      _hover={{
                        bgImage: `url('${COMMON_WEB_PATH}/now888/platform_list/${
                          direction === "col"
                            ? "platform_list_button"
                            : "platform_list_button_pc"
                        }_active.png')`,
                      }}
                      cursor="pointer"
                      bgPosition="center"
                      bgRepeat="no-repeat"
                      bgSize={direction === "col" ? "contain" : "100%100%"}
                      borderRadius={{
                        base: "0px",
                        md: "15px",
                      }}
                      position={`relative`}
                      py="10px"
                      px={{
                        base: "10px",
                        lg: "20px",
                      }}
                    >
                      <Image
                        w={{
                          base: "100%",
                          md: "85%",
                        }}
                        objectFit="contain"
                        position="relative"
                        zIndex="1"
                        src={`${COMMON_WEB_PATH}/ds88platformIcon/${thisImageNeedDark(
                          item.replace(/\s+/g, ""), // 移除所有空格
                          true
                        )}.png`}
                        alt={item}
                      />
                    </Flex>
                  </Box>
                  {/* <Box
                    position="absolute"
                    top="50%"
                    right="-9px"
                    transform={"translate(-50%, -50%)"}
                    w="10px"
                    h="80%"
                    bgImage={`url('${COMMON_WEB_PATH}/5285/platform_list/platform_list_border_blue.png')`}
                    bgSize="100% 100%"
                  ></Box> */}
                </Box>
              );
            }}
          </Link>
        </SplideSlide>
      );
    });
  }, [
    getPlatform,
    gameList,
    gameMainTypeFromProps,
    boxBg,
    textColor,
    direction,
  ]);

  // useEffect(() => {
  //   if (scrollRef.current) {
  //     if (gamePlatform) {
  //       const elementPosition = scrollRef.current.getBoundingClientRect().top;
  //       const offsetPosition = elementPosition + window.pageYOffset;
  //       console.log(elementPosition, offsetPosition, window.pageYOffset);
  //       window.scrollTo({
  //         top: offsetPosition,
  //         behavior: "smooth",
  //       });
  //     }
  //   }
  // }, [gamePlatform]);

  const handlePrev = () => {
    splideRef.current.splide.go(">");
  };

  const handleNext = () => {
    splideRef.current.splide.go("<");
  };

  useEffect(() => {
    const { platform_list } = getPlatform || {};

    if (splideRef.current) {
      const splide = splideRef.current.splide;

      splide.go(platform_list?.indexOf(gamePlatform));
    }
  }, [getPlatform, gamePlatform]);

  return (
    <Box
      ref={scrollRef}
      // bgImage={`url('${COMMON_WEB_PATH}/5285/platform_list/platform_list_background_clean_blue.png')`}
      bgPosition="center"
      bgRepeat="no-repeat"
      bgSize="100% 100%"
      //px="40px"
      px={{
        base: "15px",
        sm: direction === "col" ? 0 : "2.5%",
      }}
      position={direction === "col" ? "sticky" : "relative"}
      top={direction === "col" ? "10px" : "0px"}
      //py="40px"
      py={{
        base: "10px",
        sm: "0px",
      }}
      pt={{
        base: "10px",
        xl: direction === "col" ? "40px" : 0,
      }}
      w="100%"
      // overflowY={"scroll"}
      h={direction === "col" ? "calc(80dvh)" : ""}
    >
      <ChakraBox
        key={gameMainTypeFromProps || gameMainType}
        {...gameListFromBottom}
        position="relative"
        h="100%"
      >
        <Splide
          ref={splideRef}
          className="z-[3] !h-full"
          options={{
            wheel: true, // 啟用滾輪滾動
            pagination: false,
            arrows: false,
            drag: "free",
            lazyLoad: "nearby",
            // perPage: 5,
            direction: direction == "col" ? "ttb" : "ltr",
            fixedWidth: direction === "col" ? "150px" : "150px",
            fixedHeight: direction === "col" ? "100px" : "105px", // 每個項目的固定高度
            height: direction === "col" ? "100%" : "auto", // 根據方向設定高度
            gap: direction === "col" ? "15px" : "8px", // 項目之間的間距
            dragMinThreshold: {
              mouse: 0,
              touch: 10,
            },
            breakpoints: {
              mediaQuery: "min",
              500: {
                fixedWidth: "85px",
                gap: "8px",
                fixedHeight: direction === "col" ? "100px" : "50px", // 手機端的高度
              },
              769: {
                fixedWidth: direction === "col" ? "135px" : "150px",
              },
            },
            padding: {
              top: direction == "col" ? "10px" : "10px",
              bottom: direction == "col" ? "10px" : "10px",
            },
            start: 20, // 開始位置的邊距
            end: 0, // 結束位置的邊距
          }}
        >
          {platformList}
        </Splide>
      </ChakraBox>
      {direction === "col" ? (
        <>
          <AbsoluteCenter top="2%" onClick={handleNext} cursor="pointer">
            <Image
              src={`${COMMON_WEB_PATH}/now888/platform_list/left_mobile.png`}
              alt="arrow-left"
              h={{
                base: "30px",
                sm: "100%",
              }}
              transform={"rotate(90deg)"}
            />
          </AbsoluteCenter>
          <AbsoluteCenter top="102%" onClick={handlePrev} cursor="pointer">
            <Image
              src={`${COMMON_WEB_PATH}/now888/platform_list/right_mobile.png`}
              alt="arrow-right"
              h={{
                base: "30px",
                sm: "100%",
              }}
              transform={"rotate(90deg)"}
            />
          </AbsoluteCenter>
        </>
      ) : (
        <>
          <AbsoluteCenter
            w="15px"
            left="10px"
            onClick={handleNext}
            cursor="pointer"
          >
            <Image
              src={`${COMMON_WEB_PATH}/now888/platform_list/left_mobile.png`}
              alt="arrow-left"
              h={{
                base: "20px",
                sm: "100%",
              }}
            />
          </AbsoluteCenter>

          <AbsoluteCenter
            w="15px"
            left="calc(100% - 10px)"
            onClick={handlePrev}
            cursor="pointer"
          >
            <Image
              src={`${COMMON_WEB_PATH}/now888/platform_list/right_mobile.png`}
              alt="arrow-right"
              h={{
                base: "20px",
                sm: "100%",
              }}
            />
          </AbsoluteCenter>
        </>
      )}
    </Box>
  );
};

export default PlatformSelectorRight;
